module.exports = __webpack_public_path__ + "img/disease-pic3.a5999859.png";